import { AddCategoryFormComponent } from './add-category-form';
import { AssignRoomContentToCategoryComponent } from './assign-room-content';

export * from './add-category-form';
export * from './assign-room-content';



export const CategoryOrganisms = [
    AddCategoryFormComponent,
    AssignRoomContentToCategoryComponent
];